import { ref } from 'vue'

export function useMethods() {
    const camelCase = (s:string|undefined) => {
        if (!s) return;
        const rx = /\s([a-z])/g;
        if ( s === s.toUpperCase() ) s = s.toLowerCase();
        return s.replace(rx, function(a, b){
            return b.toUpperCase();
        });
    }

    const convertSpecialChars = (s:string|undefined) => {
        if (!s) return;
        s = s.replace(/ä/g, 'a');
        s = s.replace(/ö/g, 'o');
        s = s.replace(/Ä/g, 'A');
        s = s.replace(/Ö/g, 'O');
        s = s.replace(/ /g, '_');

        return s;
    }


    const getId = (title:string)  => {
        if (!title) return;
        let str:string | undefined;
        str = camelCase(title);
        str = convertSpecialChars(str);

        return str;
    }

    return {
        getId
    }
}



